<template>
  <div :class="$style.host">
    <div :class="$style.subtitle">
      <span>Please choose an option below</span>
    </div>
    <distributor-error></distributor-error>
    <div :class="$style.statuses">
      <div
        :class="[$style.status, {[$style.active]: isStatusExistingSelected}]"
        @click="setDistributorStatus(distributorStatusExisting)"
      >
        <div :class="$style.statusRadio"></div>
        <div :class="$style.statusTitle"><span>I am an</span></div>
        <div :class="$style.statusSubtitle">Existing Distributor</div>
      </div>
      <div
        :class="[$style.status, {[$style.active]: isStatusNewSelected}]"
        @click="setDistributorStatus(distributorStatusNew)"
      >
        <div :class="$style.statusRadio"></div>
        <div :class="$style.statusTitle"><span>I am a</span></div>
        <div :class="$style.statusSubtitle">New Customer</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import { SET_DISTRIBUTOR_STATUS } from '@/features/registration/store/modules/registration';
import DistributorStatuses from '@/features/registration/constants/distributor-statuses';
import DistributorError from '@/features/registration/components/distributor-error';

export default {
  name: 'DistributorStatus',
  components: {
    DistributorError,
  },
  data: () => ({
    distributorStatusNew: DistributorStatuses.NEW,
    distributorStatusExisting: DistributorStatuses.EXISTING,
  }),
  computed: {
    ...mapState({
      getDistributorStatus: 'distributorStatus',
    }),
    ...mapGetters([
      'isStatusNewSelected',
      'isStatusExistingSelected',
    ]),
    distributorStatus: {
      get() {
        return this.getDistributorStatus;
      },
      set(value) {
        this.setDistributorStatus(value);
      },
    },
  },
  methods: mapMutations({
    setDistributorStatus: SET_DISTRIBUTOR_STATUS,
  }),
};
</script>

<style lang="scss" module>
.host {

  .subtitle {
    margin-top: 15px;

    > span {
      @include font-open-sans-grey(16px, normal, 24px);
    }
  }

  .statuses {
    display: flex;
    justify-content: space-between;

    @media(max-width: map_get($media-max, 'md')) {
      flex-direction: column;
    }

    .status {
      border: 1px solid #c7d0db;
      background-color: #ffffff;
      padding: 35px 15px;
      margin-top: 35px;
      cursor: pointer;

      @media(min-width: map_get($media-min, 'md')) {
        width: 50%;

        &:not(:last-child) {
          margin-right: 20px;
        }
      }

      @media(max-width: map_get($media-max, 'md')) {
        margin-top: 15px;
      }

      .statusRadio {
        width: 20px;
        height: 20px;
        border: 2px solid #203e52;
        border-radius: 50%;
        position: relative;
        display: inline-block;
      }

      .statusTitle {
        margin-top: 10px;

        > span {
          @include font-open-sans-grey(14px, normal);
        }
      }

      .statusSubtitle {
        @include font-open-sans-grey(16px, bold);
      }

      &.active {
        border-color: #203e52;
        background-color: #edf6ff;

        .statusRadio {

          &:after {
            content: "";
            width: 10px;
            height: 10px;
            background-color: #203e52;
            display: inline-block;
            border-radius: 50%;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
  }
}
</style>
